import { Namespace } from '_core/utils/ssr';

export const rankingConfig = {
  i18nNamespaces: ['common', 'longtail', 'briefing'] as Namespace,
};
